import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { Link } from 'react-router';

type CoachingCardProps = {
  image: string;
  id: string;
  title: string;
  description: React.ReactNode;
};

export default function CoachingCard({ image, title, id, description }: CoachingCardProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        p: 1,
        height: '100%'
      }}
    >
      <Box
        component="img"
        src={image}
        alt={title}
        sx={{
          width: { xs: '30%', sm: '40%', md: '60%', lg:"50%" },
          maxWidth: 120,
          aspectRatio: '1 / 1',
          borderRadius: '50%',
          objectFit: 'cover',
          mb: 3,
        }}
      />

      <Typography
        variant="h5"
        fontWeight={600}
        color="text.primary"
        minHeight= '3em'
      >
        {title}
      </Typography>

      <Divider sx={{ width: '70%', my: 2, borderBottomWidth: 2 }} />

      <Typography
        variant="body1"
        color="text.secondary"

        sx={{ flexGrow: 1, width: '100%', mb: 3 }}
      >
        {description}
      </Typography>

      <Button
        variant="contained"
        color="secondary"
        size="medium"
        component={Link}
        to={`/services#${id}`}
        sx={{ mt: 'auto' }}
      >
        scopri di più
      </Button>
    </Box>
  );
}
